<template>
  <div class="h-screen flex overflow-hidden bg-gray-50">
    <!-- Off-canvas menu for mobile -->
    <div v-show="open"
      class="md:hidden">
      <div @click="open = true"
        v-show="open"
        x-transition:enter-start="opacity-0"
        x-transition:enter-end="opacity-100"
        x-transition:leave-start="opacity-100"
        x-transition:leave-end="opacity-0"
        class="fixed inset-0 z-30 transition-opacity ease-linear duration-300">
        <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
      </div>
      <div class="fixed inset-0 flex z-40">
        <div v-show="open"
          x-transition:enter-start="-translate-x-full"
          x-transition:enter-end="translate-x-0"
          x-transition:leave-start="translate-x-0"
          x-transition:leave-end="-translate-x-full"
          class="flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white transform ease-in-out duration-300">
          <div class="absolute top-0 right-0 -mr-14 p-1">
            <button v-show="open"
              @click="open = false"
              class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600">
              <svg class="h-6 w-6 text-white"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="flex-shrink-0 flex items-center px-4">
            <router-link :to="{ name: 'home' }">
              <img src="@/assets/healthy-university-logo.png"
                class="w-24" />
            </router-link>
          </div>
          <div class="mt-5 flex-1 h-0 overflow-y-auto">
            <nav class="px-2">
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'home' }"
                class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-100 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150">
                <svg
                  class="mr-3 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6" />
                </svg>
                หน้าหลัก
              </router-link>

              <a href="#"
                class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
                <svg
                  class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                </svg>
                แบบทดสอบ
              </a>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'assessment-risk' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านความเสี่ยงสุขภาพ</router-link>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'assessment-whoqol' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านคุณภาพชีวิต</router-link>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'assessment-hplp' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านพฤติกรรมสร้างเสริมสุขภาพ</router-link>
              <a href="#"
                class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
                <svg
                  class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                รายงาน
              </a>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'assessment-history.overview' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ภาพรวม</router-link>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'assessment-history.risk' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านความเสี่ยงสุขภาพ</router-link>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'assessment-history.whoqol' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านคุณภาพชีวิต</router-link>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'assessment-history.hplp' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านพฤติกรรมสร้างเสริมสุขภาพ</router-link>

              <a href="#"
                class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
                <svg
                  class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                คู่มือการใช้งาน
              </a>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'manual.assessment' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">วิธีการใช้งานระบบประเมินความเสี่ยง</router-link>
              <router-link v-on:click.native="hideMenu"
                :to="{ name: 'manual.report' }"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">วิธีการดูผลการประเมิน</router-link>
              <!-- <router-link
                v-on:click.native="hideMenu"
                :to="{name: 'manual.newsletter'}"
                class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
              >
                วิธีการเข้าร่วมกิจกรรมส่งเสริมสุขภาพ
              </router-link>-->

              <a @click="signOut"
                class="mt-8 mb-16 text-primary group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
                <svg viewBox="0 0 512.0053 512"
                  class="mr-3 h-5 w-5 fill-current text-gray-600 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M320 277.336c-11.7969 0-21.332 9.5585-21.332 21.332v85.336c0 11.7538-9.5586 21.332-21.336 21.332h-64v-320c0-18.2188-11.6054-34.4962-29.0547-40.5547l-6.3164-2.1133h99.3711c11.7774 0 21.336 9.578 21.336 21.336v64c0 11.7733 9.5351 21.332 21.332 21.332s21.332-9.5587 21.332-21.332v-64c0-35.2853-28.7148-64-64-64H48c-.8125 0-1.4922.3632-2.2812.4687-1.0274-.086-2.0079-.4688-3.0508-.4688C19.1367.004 0 19.1367 0 42.668v384c0 18.2188 11.6055 34.4962 29.0547 40.5548l128.3867 42.7968c4.3516 1.3438 8.6797 1.9844 13.2266 1.9844 23.5312 0 42.664-19.1367 42.664-42.668v-21.332h64c35.2852 0 64-28.7148 64-64v-85.336c0-11.7734-9.5351-21.332-21.332-21.332zm0 0" />
                  <path
                    d="M505.75 198.254l-85.336-85.3321c-6.0976-6.1016-15.2734-7.9375-23.25-4.6328-7.957 3.3086-13.164 11.0937-13.164 19.7148v64h-85.332c-11.7774 0-21.336 9.5547-21.336 21.332 0 11.7774 9.5586 21.332 21.336 21.332H384v64c0 8.6212 5.207 16.4063 13.164 19.715 7.9766 3.3046 17.1524 1.4687 23.25-4.629l85.336-85.336c8.3398-8.3398 8.3398-21.8242 0-30.164zm0 0" />
                </svg>
                ออกจากระบบ
              </a>
            </nav>
          </div>
        </div>
        <div class="flex-shrink-0 w-14">
          <!-- Force sidebar to shrink to fit close icon -->
        </div>
      </div>
    </div>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64 border-r border-gray-200 pt-5 pb-4 bg-white">
        <div class="flex items-center justify-center flex-shrink-0 px-4">
          <img src="@/assets/healthy-university-logo.png"
            class="w-24" />
        </div>
        <div class="mt-5 h-0 flex-1 flex flex-col overflow-y-auto">
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <nav class="flex-1 px-2 bg-white">
            <router-link :to="{ name: 'assessments' }"
              class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-100 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150">
              <svg
                class="mr-3 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6" />
              </svg>
              หน้าหลัก
            </router-link>

            <a href="#"
              class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
              </svg>
              แบบทดสอบ
            </a>
            <router-link :disabled="completion.assessments.risk_assessment"
              :to="{ name: 'assessment-risk' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
              ด้านความเสี่ยงสุขภาพ
              <svg v-show="completion.assessments.risk_assessment"
                class="w-4 h-4 ml-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 367.805 367.805">
                <path
                  d="M183.903.001c101.566 0 183.902 82.336 183.902 183.902s-82.336 183.902-183.902 183.902S.001 285.469.001 183.903C-.288 82.625 81.579.29 182.856.001h1.047z"
                  fill="#3bb54a" />
                <path fill="#d4e1f4"
                  d="M285.78 133.225L155.168 263.837l-73.143-72.62 29.78-29.257 43.363 42.841 100.833-100.833z" />
              </svg>
            </router-link>
            <router-link :disabled="completion.assessments.whoqol_assessment"
              :to="{ name: 'assessment-whoqol' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
              ด้านคุณภาพชีวิต
              <svg v-show="completion.assessments.whoqol_assessment"
                class="w-4 h-4 ml-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 367.805 367.805">
                <path
                  d="M183.903.001c101.566 0 183.902 82.336 183.902 183.902s-82.336 183.902-183.902 183.902S.001 285.469.001 183.903C-.288 82.625 81.579.29 182.856.001h1.047z"
                  fill="#3bb54a" />
                <path fill="#d4e1f4"
                  d="M285.78 133.225L155.168 263.837l-73.143-72.62 29.78-29.257 43.363 42.841 100.833-100.833z" />
              </svg>
            </router-link>
            <router-link :disabled="completion.assessments.hplp_assessment"
              :to="{ name: 'assessment-hplp' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
              ด้านพฤติกรรมสร้างเสริมสุขภาพ
              <svg v-show="completion.assessments.hplp_assessment"
                class="w-4 h-4 ml-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 367.805 367.805">
                <path
                  d="M183.903.001c101.566 0 183.902 82.336 183.902 183.902s-82.336 183.902-183.902 183.902S.001 285.469.001 183.903C-.288 82.625 81.579.29 182.856.001h1.047z"
                  fill="#3bb54a" />
                <path fill="#d4e1f4"
                  d="M285.78 133.225L155.168 263.837l-73.143-72.62 29.78-29.257 43.363 42.841 100.833-100.833z" />
              </svg>
            </router-link>
            <a href="#"
              class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              รายงาน
            </a>
            <router-link :to="{ name: 'assessment-history.overview' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ภาพรวม</router-link>
            <router-link :to="{ name: 'assessment-history.risk' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านความเสี่ยงสุขภาพ</router-link>
            <router-link :to="{ name: 'assessment-history.whoqol' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านคุณภาพชีวิต</router-link>
            <router-link :to="{ name: 'assessment-history.hplp' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">ด้านพฤติกรรมสร้างเสริมสุขภาพ</router-link>

            <a href="#"
              class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
              <svg
                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24">
                <path stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              คู่มือการใช้งาน
            </a>
            <router-link v-on:click.native="hideMenu"
              :to="{ name: 'manual.assessment' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">วิธีการใช้งานระบบประเมินความเสี่ยง</router-link>
            <router-link v-on:click.native="hideMenu"
              :to="{ name: 'manual.report' }"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">วิธีการดูผลการประเมิน</router-link>
            <!-- <router-link
              v-on:click.native="hideMenu"
              :to="{name: 'manual.newsletter'}"
              class="mt-1 pl-11 group flex items-center px-2 py-2 text-sm leading-5 font-light text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
            >
              วิธีการเข้าร่วมกิจกรรมส่งเสริมสุขภาพ
            </router-link>-->

            <a @click="signOut"
              class="mt-8 mb-16 text-primary group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150">
              <svg viewBox="0 0 512.0053 512"
                class="mr-3 h-5 w-5 fill-current text-gray-600 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M320 277.336c-11.7969 0-21.332 9.5585-21.332 21.332v85.336c0 11.7538-9.5586 21.332-21.336 21.332h-64v-320c0-18.2188-11.6054-34.4962-29.0547-40.5547l-6.3164-2.1133h99.3711c11.7774 0 21.336 9.578 21.336 21.336v64c0 11.7733 9.5351 21.332 21.332 21.332s21.332-9.5587 21.332-21.332v-64c0-35.2853-28.7148-64-64-64H48c-.8125 0-1.4922.3632-2.2812.4687-1.0274-.086-2.0079-.4688-3.0508-.4688C19.1367.004 0 19.1367 0 42.668v384c0 18.2188 11.6055 34.4962 29.0547 40.5548l128.3867 42.7968c4.3516 1.3438 8.6797 1.9844 13.2266 1.9844 23.5312 0 42.664-19.1367 42.664-42.668v-21.332h64c35.2852 0 64-28.7148 64-64v-85.336c0-11.7734-9.5351-21.332-21.332-21.332zm0 0" />
                <path
                  d="M505.75 198.254l-85.336-85.3321c-6.0976-6.1016-15.2734-7.9375-23.25-4.6328-7.957 3.3086-13.164 11.0937-13.164 19.7148v64h-85.332c-11.7774 0-21.336 9.5547-21.336 21.332 0 11.7774 9.5586 21.332 21.336 21.332H384v64c0 8.6212 5.207 16.4063 13.164 19.715 7.9766 3.3046 17.1524 1.4687 23.25-4.629l85.336-85.336c8.3398-8.3398 8.3398-21.8242 0-30.164zm0 0" />
              </svg>
              ออกจากระบบ
            </a>
          </nav>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <div v-show="!liff.isInClient()"
        class="relative z-10 flex-shrink-0 flex h-16 bg-white shadow">
        <button @click.stop="open = true"
          class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden">
          <svg class="h-6 w-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24">
            <path stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h7" />
          </svg>
        </button>
        <div class="flex-1 px-4 flex justify-between max-w-7xl">
          <div class="flex-1 flex"></div>
          <div class="ml-4 flex items-center md:ml-6">
            <div>{{ user.firstname }} {{ user.lastname }}</div>
            <div class="ml-3 relative">
              <div>
                <button @click="open = !open"
                  class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:shadow-outline">
                  <img class="h-8 w-8 rounded-full"
                    src="@/assets/default-profile-picture.jpg"
                    alt />
                </button>
              </div>
              <div v-show="open"
                x-transition:enter="transition ease-out duration-100"
                x-transition:enter-start="transform opacity-0 scale-95"
                x-transition:enter-end="transform opacity-100 scale-100"
                x-transition:leave="transition ease-in duration-75"
                x-transition:leave-start="transform opacity-100 scale-100"
                x-transition:leave-end="transform opacity-0 scale-95"
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">
                <div class="py-1 rounded-md bg-white shadow-xs">
                  <a @click="signOut"
                    href="#"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">ออกจากระบบ</a>
                </div>
              </div>
            </div>
            <button @click="toggleMenu"
              class="p-1 ml-2">
              <svg class="h-3 w-3 text-gray-400 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 255 255">
                <path d="M0 63.75l127.5 127.5L255 63.75z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <main id="main"
        class="flex-1 relative z-0 overflow-y-auto focus:outline-none bg-white"
        tabindex="0">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8"></div>
        <div class="mx-auto bg-user">
          <router-view></router-view>

          <!-- reserve for background -->
          <div style="height: 320px"></div>
        </div>
      </main>
      <!-- <div class="text-center py-4 bg-primary w-full">
        <p class="text-white font-light px-4">
          CMU i-Heath
          เป็นลิขสิทธิ์ของโครงการพัฒนาศักยภาพการสร้างเสริมสุขภาพของบุคลากรมหาวิทยาลัยเชียงใหม่
          สำหรับการขับเคลื่อนสู่มหาวิทยาลัยสุขภาพ ไม่อนุญาตให้ลอกเลียนแบบ นำไปใช้
          หรือทำซ้ำโดยไม่ได้รับอนุญาต
        </p>
      </div>-->
    </div>

    <a-modal v-model="cookieModal"
      title="นโยบายคุ้มครองข้อมูลส่วนบุคคล"
      :width="640"
      okText="ยอมรับ"
      @ok="acceptCookie"
      @cancel="showHealthyCmu"
      cancelText="ยกเลิก"
      class="text-left">
      <p class="text-lg mb-4">
        CMU i Health
        ระบบสารสนเทศเพื่อประเมินความเสี่ยงด้านสุขภาพสำหรับบุคลากรมหาวิทยาลัยเชียงใหม่
      </p>

      <p class="text-lg font-bold">ข้อมูลส่วนบุคคล คืออะไร?</p>

      <p class="text-lg mb-4">
        ข้อมูลส่วนบุคคล หมายถึง ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวตนบุคคลนั้นได้
        ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ
        ลักษณะข้อมูลส่วนบุคคลที่เราเก็บรวบรวม เราจะเก็บรวบรวมข้อมูลส่วนบุคคลดังต่อไปนี้
      </p>
      <p class="text-lg leading-tight mb-2">
        1.ข้อมูลที่บ่งชี้ตัวตน ได้แก่ ชื่อ นามสกุล เพศ ประเภทบุคลากร
      </p>
      <p class="text-lg leading-tight mb-2">
        2.ข้อมูลช่องทางการติดต่อ อาทิ คณะที่สังกัด อีเมล เบอร์โทรศัพท์* Line Account*
      </p>
      <p class="text-lg leading-tight mb-2">
        3.ข้อมูลทางเทคนิค อาทิ Google Analytics หมายเลขระบุตำแหน่งคอมพิวเตอร์ (IP Address)
      </p>
      <p class="text-lg leading-tight mb-2">4.ข้อมูลการใช้งานระบบ และ การตั้งค่า (log)</p>
      <p class="text-lg leading-tight mb-2">*(ท่านสามารถไม่ให้ข้อมูลส่วนนี้ได้)</p>

      <p class="text-lg font-bold mt-8">แหล่งที่มาของข้อมูลส่วนบุคคล</p>

      <p class="text-lg mb-4">
        เราได้รับข้อมูลส่วนบุคคลจากท่านโดยตรง
        โดยเราจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากขั้นตอนการให้บริการดังนี้
      </p>

      <p class="text-lg leading-tight mb-2">
        1. เมื่อท่านเข้าใช้งานระบบผ่าน CMU Account เพื่อใช้บริการกับระบบ CMU i Health
      </p>
      <p class="text-lg leading-tight mb-2">2. จากความสมัครใจของท่านในการทำแบบสอบถาม</p>
      <p class="text-lg leading-tight mb-2">
        3. จากการติดต่อสอบถามของท่าน หรือผ่านการโต้ตอบทางอีเมลหรือ ช่องทางการสื่อสารอื่นๆ
        เช่น Line Account เพื่อที่ CMU i Health สามารถติดต่อท่านกลับได้
      </p>
      <p class="text-lg leading-tight mb-2">
        4. เราได้รับข้อมูลส่วนบุคคลพื้นฐาน ประกอบด้วย ชื่อ นามสกุล คณะที่สังกัด
        ประเภทบุคลากร เพศ อีเมล ของท่านมาจาก กองบริหารงานบุคคลมหาวิทยาลัยเชียงใหม่
      </p>
      <p class="text-lg leading-tight mb-2">
        5. ข้อมูลหมายเลข โทรศัพท์มือถือปัจจุบันสำหรับการรับข้อมูลจากระบบในอนาคต
        จากความสมัครใจของท่านในการทำแบบสอบถาม (ผู้ใช้สามารถเลือกไม่ให้ข้อมูลได้)
      </p>
      <p class="text-lg leading-tight mb-2">
        6. ข้อมูล Line Account สำหรับการรับข้อมูลจากระบบในอนาคต
        (ผู้ใช้สามารถเลือกไม่ให้ข้อมูลได้)
      </p>

      <p class="text-lg font-bold mt-8">วัตถุประสงค์ในการประมวลผลข้อมูล</p>
      <p class="text-lg mb-4">
        CMU i Health
        เก็บข้อมูลส่วนบุคคลของท่านเพื่อประโยชน์ในการประเมินความเสี่ยงสุขภาพของบุคลากรในภาพรวมของมหาวิทยาลัยเชียงใหม่
        โดย CMU i Health
        จะไม่ระบุเจาะจงตัวตนผู้ที่มีความเสี่ยงด้านสุขภาพเป็นการประมวลผลเชิงภาพรวมเท่านั้น
      </p>

      <p class="text-lg font-bold mt-8">การประมวลผลข้อมูลส่วนบุคคล</p>
      <p class="text-lg mb-4">
        เมื่อได้รับข้อมูลส่วนบุคคลจากท่านแล้ว CMU i Health จะดำเนินการดังนี้
      </p>

      <p class="text-lg leading-tight mb-2">
        1. CMU i Health เก็บรวบรวมโดยมีการบันทึกใน Server
        ใช้บริการของสำนักบริการเทคโนโลยีสารสนเทศ มหาวิทยาลัยเชียงใหม่ (ITSC)
      </p>
      <p class="text-lg leading-tight mb-2">
        2. CMU i Health
        จะใช้ข้อมูลส่วนบุคคลพื้นฐานของท่านเพื่อประมวลผลภาพรวมความเสี่ยงด้านสุขภาพที่แบ่งเป็น
        3 แบบคัดกรอง ประกอบด้วย 1. แบบคัดกรองความเสี่ยงด้านสุขภาพ (Health risk assessment)
        2.แบบประเมินคุณภาพชีวิตขององค์การอนามัยโลกแบบย่อ (WHOQOL-BREF) 3.
        แบบประเมินพฤติกรรมสร้างเสริมสุขภาพ (Health Promoting Lifestyle Profile II)
      </p>
      <p class="text-lg leading-tight mb-2">
        3. นำเสนอเป็นข้อมูลเชิงสรุป จำนวนผู้ที่มีความเสี่ยง ร้อยละ และคะแนนเฉลี่ยๆ
        ของความเสี่ยงด้านต่าง ๆ โดยรวมของบุคลากรมหาวิทยาลัยเชียงใหม่ ซึ่ง สามารถ สรุปผล
        แบ่งตามรายเพศ รายคณะ รายประเภทบุคลากร
      </p>

      <p class="text-lg font-bold mt-8">
        การเก็บรักษาและระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล
      </p>
      <p class="text-lg font-bold">การเก็บรักษาข้อมูลส่วนบุคคล</p>

      <p class="text-lg leading-tight mb-2">
        1. เมื่อท่านเข้าใช้งานระบบผ่าน CMU Account เพื่อใช้บริการกับระบบ CMU i Health
      </p>
      <p class="text-lg leading-tight mb-2">
        ผู้ควบคุมทำการเก็บรักษาข้อมูลส่วนบุคคลของท่าน ดังนี้
      </p>
      <p class="text-lg leading-tight mb-2">
        1. ข้อมูลส่วนบุคคลที่ CMU i Health จัดเก็บจะอยู่ในลักษณะของ Soft Copy
      </p>
      <p class="text-lg leading-tight mb-2">
        2. ข้อมูลส่วนบุคคลจะถูกจัดเก็บไว้บน Server สำนักบริการเทคโนโลยีสารสนเทศ
        มหาวิทยาลัยเชียงใหม่ (ITSC)
      </p>
      <p class="text-lg leading-tight mb-2">
        3. ระยะเวลารักษาข้อมูล ส่วนบุคคลของท่าน
        ภายในระยะเวลาโครงการขับเคลื่อนมหาวิทยาลัยเชียงใหม่สู่มหาวิทยาลัยสุขภาพ
        (ระยะเวลาโครงการ มกราคม 2563 - ธันวาคม 2564)
      </p>

      <p class="text-lg font-bold mt-8">สิทธิของเจ้าของข้อมูล</p>

      <p class="text-lg leading-tight mb-2">ท่านมีสิทธิในการดำเนินการ ดังต่อไปนี้</p>
      <p class="text-lg leading-tight mb-2">
        ผู้ควบคุมทำการเก็บรักษาข้อมูลส่วนบุคคลของท่าน ดังนี้
      </p>
      <p class="text-lg leading-tight mb-2">
        1. สิทธิในการเพิกถอนความยินยอม (right to withdraw consent):
        ท่านมีสิทธิในการเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมได้ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของท่านอยู่กับโครงการ
      </p>
      <p class="text-lg leading-tight mb-2">
        2.สิทธิในการเข้าถึงข้อมูลส่วนบุคคล (right of access):
        ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านผ่าน CMU Account
        เพื่อเรียกดูข้อมูลความเสี่ยงด้านสุขภาพย้อนหลังของตัวท่านเองได้
      </p>
      <p class="text-lg leading-tight mb-2">
        3.สิทธิในการลบข้อมูลส่วนบุคคล (right to erasure): ท่านมีสิทธิในการขอให้ CMU i
        Health ทำการลบข้อมูลของท่านด้วยเหตุบางประการได้
      </p>

      <p class="text-lg leading-tight mb-2">
        4.สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (right to object):
        ท่านมีสิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้
      </p>

      <p class="text-lg leading-tight mb-2">
        ท่านสามารถติดต่อมายังผู้ดูแลระบบได้
        เพื่อดำเนินการยื่นคำร้องขอดำเนินการตามสิทธิข้างต้นได้ ผ่าน
        cmuhealth-admin@cmu.ac.th
      </p>

      <p class="text-lg leading-tight mb-2">
        ทั้งนี้ ท่านไม่จำเป็นต้องเสียค่าใช้จ่ายใดๆ ในการดำเนินตามสิทธิข้างต้น โดย CMU i
        Health จะพิจารณาและแจ้งผลการพิจารณาคำร้องของท่านภายใน 30
        วันนับแต่วันที่เราได้รับคำร้องขอดังกล่าว
      </p>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import liff from "@line/liff";

export default {
  async created() {
    const response = await axios({
      method: "GET",
      url: `${process.env.VUE_APP_API_URL}/me/profile`,
      headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
    });

    const user = response.data;

    this.$store.dispatch("updateUser", user);

    if (localStorage.getItem("ACCPET_COOKIE")) {
      this.cookieModal = false;
    } else {
      this.cookieModal = true;
    }

    this.fetchCompletion();
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/me/profile`,
        headers: {
          authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
        },
      });

      next();
    } catch (error) {
      next({ name: "home" });
    }
  },
  data() {
    return {
      open: false,
      cookieModal: false,
      completion: {},

      liff,
    };
  },
  methods: {
    toggleMenu() {
      this.open = !this.open;
    },
    signOut() {
      localStorage.clear();

      this.$router.push({ path: "/" });
    },
    hideMenu() {
      console.log("hide menu");

      this.open = false;
    },
    acceptCookie() {
      localStorage.setItem("ACCPET_COOKIE", true);

      this.cookieModal = false;
    },
    showHealthyCmu() {
      console.log("test");

      window.location = "https://healthycmu.com/";
    },
    async fetchCompletion() {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/me/monthly-completion/check`,
        headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
      });

      this.completion = response.data;
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isCompleted() {
      if (Object.keys(this.completion).length === 0) {
        return false;
      }

      return Object.values(this.completion.assessments).every((completed) => completed);
    },
  },
};
</script>

<style lang="css">
.ant-modal-body {
  height: 512px;
  overflow-y: scroll;
}

/* .bg-user {
  background-image: url("https://firebasestorage.googleapis.com/v0/b/cmu-hms.appspot.com/o/bg%2F5063406.jpg?alt=media&token=dff087d2-7fb9-49b4-ab60-bfbc7a41c568");
  background-size: 500px;
  background-repeat: no-repeat;
  background-position: bottom right;
} */
</style>
